document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.add-to-cart').forEach(button => {
    button.addEventListener('click', async function() {
      const variantId = this.getAttribute('data-variant-id');
      const isSoldOut = this.getAttribute('data-sold-out') === 'true';
      
      if (!variantId) {
        console.error('Variant ID missing');
        return;
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });

        if (!response.ok) {
          const errorData = await response.json();
          console.error('Error:', errorData);

          if (isSoldOut) {
            alert('This product is currently out of stock but will be added as a preorder.');
          } else {
            alert(errorData.message || 'Failed to add product to cart.');
          }
          return;
        }

        const data = await response.json();
        console.log('Added to cart:', data);

        alert(isSoldOut ? 'Preorder added to cart!' : 'Product added to cart!');
      } catch (error) {
        console.error('Fetch error:', error);
      }
    });
  });
});